import { Button, Text } from '@chakra-ui/react';
import { ReactComponent as LinkIcon } from '../resources/link-alt.svg';

export default function CopyProfileButton({ slug }: { slug?: string }) {
    return (
        <Button
            backgroundColor="brand.25"
            color="brand.500"
            mt="4"
            _hover={{
                bg: 'brand.50'
            }}
            fontSize={{ base: '16px' }}
            width={{ base: '100%' }}
            onClick={() => {
                navigator.clipboard.writeText(`app.pathmatch.com/profile/${slug}`);
            }}
        >
            <Text mr="1" className="copyButtonText">
                Copy Profile URL
            </Text>
            <LinkIcon fill="var(--chakra-colors-brand-500)" />
        </Button>
    );
}
